export interface DefaultApiErrorType extends Error {
    rawResponse?: ApiErrorResponseType;
    response?: string | ApiErrorViolationType[];
    status?: number;
}
// Handles API response errors
export function defaultApiResponseHandler(error: CustomError) {
    const e: DefaultApiErrorType = new Error('An error occurred');
    const { response } = error;
    e.rawResponse = response;

    if (response && response.data) {
        if (response.data.violations) {
            e.response = response.data.violations;
        } else if (response.data.message) {
            e.response = response.data.message;
        } else if (response.data['hydra:title']) {
            e.response = `${response.data['hydra:title']}: ${response.data['hydra:description']}`;
        }
    }

    if (error.status) {
        e.status = error.status;
    }

    return e;
}
